module.exports = __webpack_public_path__ + "media/images/email_stamp-cf9a2103371317a9d1fccc949c84b7d7.png";